module.exports = __webpack_public_path__ + "static/BeVietnam-Regular-75cd4bd2a5649bd7ab4d6ba26828cb77.woff2";